import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=c9a14326"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a14326')) {
      api.createRecord('c9a14326', component.options)
    } else {
      api.reload('c9a14326', component.options)
    }
    module.hot.accept("./strategy.vue?vue&type=template&id=c9a14326", function () {
      api.rerender('c9a14326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/stock/audit/strategy.vue"
export default component.exports